const enterpriseCertification = {
  CompanyAuthenticating: ["企业认证", "Company Authenticating"],
  AddCompanyAuthenticating: ["新增企业认证", "Add Company Authenticating"],
  InitiateCompanyAuthenticating: [
    "发起企业认证",
    "Initiate Company Authenticating",
  ],
  FillInTheCompanyInformation: [
    "填写企业信息",
    "Fill in the company information",
  ],
  ChooseAnAuthenticationMethod: [
    "选择认证方式",
    "Choose an authentication method",
  ],
  PublicAccountAuthentication: [
    "对公账户认证",
    "Public account authentication",
  ],
  WaitingForTheLegalPersonToSign: [
    "等待法人签署",
    "Waiting for the legal person to sign",
  ],
  CompanyAuthenticationCompleted: [
    "企业认证完成",
    "Company Authentication completed",
  ],
  TheCurrentCompanyIsNotAuthenticated: [
    "当前企业未认证",
    "The current Company is not authenticated",
  ],
  StartAuthenticating: ["开始认证", "Start authenticating"],
  CompanyName: ["企业名称", "Company name"],
  PleaseEnterCompanyName: ["请输入企业名称", "Please enter company name"],
  UnifiedSocialCreditCode: ["统一社会信用代码", "Unified Social Credit Code"],
  PleaseEnterTheUnifiedSocialCreditCode: [
    "请输入统一社会信用代码",
    "Please enter the Unified Social Credit Code",
  ],
  LegalRepresentative: ["法定代表人", "Legal representative"],
  PleaseEnterLegalRepresentative: [
    "请输入法定代表人",
    "Please enter legal representative",
  ],
  SaveSuccessfully: ["保存成功", "Save successfully"],
  TheCurrentEnterpriseHasCompletedTheCertification: [
    "当前企业已完成认证，请联系管理员{userName}加入企业。",
    "The current enterprise has completed the certification. Please contact the administrator {userName} to join the enterprise.",
  ],
  NextStep: ["下一步", "Next step"],
  LegalRepresentativeAuthentication: [
    "法定代表人认证",
    "Legal representative authentication",
  ],
  RecommendedImmediate: ["推荐，即时", "recommended, immediate"],
  CorporateAccountAuthentication: [
    "对公账户认证",
    "Corporate account authentication",
  ],
  SmallTransferToCorporateAccountAbout12WorkingDays: [
    "对公账户小额转账，约1-2个工作日",
    "small transfer to corporate account, about 1-2 working days",
  ],
  Authenticating: ["认证", "Authenticating"],
  PleaseSelectASignatory: ["请选择签署人", "Please select a signatory"],
  IAmTheLegaRepresentative: ["我是法人", "I am the lega representative"],
  CurrentAccountSigned: ["当前账号签署", "current account signed"],
  IAmNotALegalRepresentative: ["我不是法人", "I am not a legal representative"],
  SentToLegalPersonForSignature: [
    "发送给法人签署",
    "sent to legal person for signature",
  ],
  Authentication: ["身份验证", "Authentication"],
  VerifyThatTheLegalRepresentativeInformationIsConsistentWithTheInformationInTheBusinessRegister:
    [
      "验证法人信息与工商登记的信息一致",
      "Verify that the legal representative information is consistent with the information in the business register",
    ],
  SendTheCertificationAuthorizationLetterToTheLegalPersonForSignature: [
    "发送认证授权书给法人签署",
    "Send the certification authorization letter to the legal person for signature",
  ],
  MobilePhoneNumber: ["法人手机号", "Mobile phone number"],
  pleaseEnterTheMobilePhoneNumberOfTheLegalRepresentative: [
    "请输入法人手机号",
    "Please enter the mobile phone number of the legal representative",
  ],
  IDNumber: ["身份证号", "ID number"],
  PleaseEnterIDNumber: ["请输入法人身份证号", "Please enter ID number"],
  TheRealNameInformationOfTheLegalRepresentativeHasNotPassed: [
    "法人实名信息未通过",
    "The real-name information of the legal representative has not passed",
  ],
  SendTheNumberOfAuthenticationAuthorizationsToTheLegalRepresentativeForSignature:
    [
      "发送认证授权数给法人签署",
      "Send the number of authentication authorizations to the legal representative for signature",
    ],
  Step1: [
    "第1步：请下载原件并打印，填写后加盖公章，扫描（拍照）后上传",
    "Step 1: Please download the original and print it, fill it out and stamp it, scan (take photos) and upload it",
  ],
  AuthenticationPowerOfAttorney: [
    "认证授权书",
    "Authentication Power of Attorney",
  ],
  DownloadTheOriginal: ["下载原件", "Download the original"],
  View: ["查看", "View"],
  CertificationProgress: ["认证进度", "Certification progress"],
  Step2: [
    "第2步：完成上一步操作后，用公司的对公账户转账0.01元给平台",
    "Step 2: After completing the previous operation, transfer 0.01 yuan to the platform with the company's corporate account",
  ],
  TransferMoney: ["转账", "Transfer money"],
  NotStarted: ["未开始", "Not started"],
  InProgress: ["进行中", "In progress"],
  DidNotPass: ["未通过", "Did not pass"],
  Cancelled: ["已取消", "Cancelled"],
  Step3: [
    "第3步：完成上一步操作后，提交资料，等待人工审核",
    "Step 3: After completing the previous step, submit the information and wait for manual review",
  ],
  ManualReview: ["人工审核", "Manual review"],
  Submit: ["提交", "Submit"],
  YourBusinessPaidBy: ["您的企业（付款方）", "Your business (paid by)"],
  YouNeedToTransferYuanToTheFollowingAccountForCompanyAuthentication: [
    "需向以下账户（收款方）转账0.01元，用于企业认证",
    "You need to transfer 0.01 yuan to the following account (recipient) for Company authentication",
  ],
  AccountName: ["开户名称", "Account name"],
  ShanghaiHippocratesHealthTechnologyCoLtd: [
    "上海辛格迪健康科技有限公司",
    "Shanghai HippocratesHealth Technology Co., Ltd",
  ],
  Bank: ["开户银行", "Bank"],
  IndustrialAndCommercialBankOfChinaCoLtdShanghaiZhangjiangSubBranch: [
    "中国工商银行股份有限公司上海市张江支行",
    "Industrial and Commercial Bank of China Co., Ltd. Shanghai Zhangjiang Sub-branch",
  ],
  AccountNumber: ["开户账号", "Account number"],
  PleaseEnsureThatThePayerIsHeadedTo: [
    "请确保付款方抬头为",
    "Please ensure that the payer is headed to",
  ],
  HippocratesHealth: ["辛格迪健康HippocratesHealth", "HippocratesHealth"],
  AfterTheTransferPleaseUploadAScreenshotOfTheTransferRecordIncludingTheNameOfThePayerAndTheTransactionTime:
    [
      "转账后，请上传转账记录的截图，截图内容包括付款方名称和交易时间等信息",
      "After the transfer, please upload a screenshot of the transfer record, including the name of the payer and the transaction time",
    ],
  Sample: ["示例", "Sample"],
  SendTheFollowingInformationToThePlatformForManualReview: [
    "将下列资料发送给平台方人工审核？",
    "Send the following information to the platform for manual review?",
  ],
  TransferRecords: ["转账记录", "Transfer records"],
  TipIfTheAboveInformationIsIncorrectYouCanExitAndModifyTheInformationBeforeSubmitting:
    [
      "提示：若上述信息有误，可退出后修改信息，再提交",
      "Tip: If the above information is incorrect, you can exit and modify the information before submitting",
    ],
  NotCertified: ["未认证", "not certified"],
  WaitingForSignatureOfLegalPerson: [
    "等待法人签署",
    "Waiting for signature of legal person",
  ],
  CertificationCompleted: ["认证完成", "Certification completed"],
  LegalPersonHasDeclined: ["法人已拒绝", "Legal person has declined"],
  DoYouWantToReInitiateSigning: [
    "是否要重新发起签署？",
    "Do you want to re-initiate signing?",
  ],
  DoYouWantToCancelSigning: [
    "是否要取消签署？取消后可重新选择认证方式。",
    "Do you want to cancel signing? You can reselect the authentication method after canceling.",
  ],
  CancelSuccess: ["取消成功", "Cancel success"],
  CancellationFailed: ["取消失败", "Cancellation failed"],
  CorporateInformation: ["企业信息", "Corporate Information"],
  PleaseUploadAuthorizationLetter: [
    "请上传授权书",
    "Please upload authorization letter",
  ],
  PleaseUploadTransferRecords: [
    "请上传转账记录",
    "Please upload transfer records",
  ],
  SubmittedWaitingForManualReview: [
    "已提交，等待人工审核",
    "Submitted, waiting for manual review",
  ],
  PleaseUploadTheSignedAndSealedAuthorizationLetter: [
    "请将签署并盖章的授权书上传",
    "Please upload the signed and sealed authorization letter",
  ],
  PleaseDrawYourPersonalSignature: [
    "请绘制个人签名",
    "Please draw your personal signature",
  ],
  InOrderToAccuratelyIdentifyYourSignaturePleaseDrawItAccordingToTheTemplate: [
    "为了能准确识别您的签名请按照模版绘制",
    "In order to accurately identify your signature, please draw it according to the template.",
  ],
  Rewrite: ["重写", "rewrite"],
  SignHere: ["在此签署", "sign here"],
  Close: ["关闭", "Close"],
  AuthenticationSuccessful: ["认证成功", "Authentication successful"],
  VerificationPassed: ["验证通过", "Verification passed"],
};

export default enterpriseCertification;
